import React from 'react';

//COMPONENTE
import KOGFileUploader from '@/main/components/shared/fileUploader/fileUploader';
import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';

//SERVICES/API
import { getTranslateByKey } from '@/main/services/utils';

//SCREENS/COMPONENTS/STYLES LOCAL
import * as S from './styles';



interface IChangeStatusFileUpload {
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

function ChangeStatusFileUpload({
  files,
  setFiles
}: IChangeStatusFileUpload) {

  return (
    <S.Content>
      <ColumnLabel
        label={getTranslateByKey('information.uploadFiles')}
        content={
          <KOGFileUploader
            isFullScreenDragDrop
            files={files}
            showPreviewImages={false}
            setFiles={setFiles}
            maxFiles={3}
            typeFiles={['image', 'document']}
          />
        }
      />
    </S.Content>
  );
}

export default ChangeStatusFileUpload;
